// lipFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}


interface internalLinking {
    heading: string;
    items: [] | any;
}
interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    internalLinking: internalLinking;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const lipFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Lip Fillers Dubai | Best Clinic in Dubai UAE for Fip Fillers",
            "description": "Elite Body Home Polyclinic offers the best lip fillers in Dubai for naturally plump, trendy pouts using premium products like Juvederm, Stylage, and Teosyal.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/lip-fillers-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Lip Fillers Dubai | Best Clinic in Dubai UAE for Fip Fillers",
                "description": "Elite Body Home Polyclinic offers the best lip fillers in Dubai for naturally plump, trendy pouts using premium products like Juvederm, Stylage, and Teosyal.",
                "url": "https://elitebodyhome.com/lip-fillers-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:39:41+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-41.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-41.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Lip Fillers Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Lip Fillers Dubai | Best Clinic in Dubai UAE for Fip Fillers",
                "description": "Elite Body Home Polyclinic offers the best lip fillers in Dubai for naturally plump, trendy pouts using premium products like Juvederm, Stylage, and Teosyal.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-41.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Dubai Lip Fillers"],
        "hero": {
            "title": "Dubai Lip Fillers",
            "subtitle": "A Pout That Defines Beauty!",
            "description": "The Definition of Beauty in a Pout! Desire plumper, younger lips? Lip fillers can help you get the lips of your dreams with their subtle, natural results that enhance your complete appearance. Our lip filler operations in Dubai offer a quick and simple solution for defining your lip contour, adding volume, and smoothing out minor creases."
        },
        "howItWorks": {
            "title": "How Do Fillers for the Lips Work?",
            "description": "Non-surgical injections called lip fillers increase the volume, shape, and hydration of your lips. Because the fillers contain hyaluronic acid (HA), a substance that the body naturally produces to retain moisture, your lips will appear larger and more hydrated. This technique blends in perfectly with the tissue of your lips, giving them a delicate, natural look."
        },
        "procedureSteps": {
            "heading": "Methodology",
            "para": "Lip fillers are injected into the lips to enhance volume, smooth out small creases, and define the lip borders. The main element in most fillers is hyaluronic acid, a substance that occurs naturally in the body and keeps the skin hydrated and plump.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "To determine your objectives and evaluate your lip shape, a thorough consultation is held.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Numbing",
                    "desc": "To reduce pain during the injection, a topical numbing lotion is used.",
                    "icon": "fa-solid fa-spray-can"
                },
                {
                    "title": "Injections",
                    "desc": "To get the correct volume and form, the filler is carefully injected into particular lip areas using a tiny needle.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Shaping",
                    "desc": "For a smooth, natural-looking finish, the lips are gently massaged to distribute the filler uniformly.",
                    "icon": "fa-solid fa-hand-sparkles"
                }
            ]
        },

        "internalLinking": {
            "heading": "Explore Our Dermal Fillers for Complete Facial Enhancement",
            "items": [{ "name": "Chin Fillers", "link": "/services/chin-fillers-dubai" },
            { "name": "Nose Fillers", "link": "/services/nose-fillers-dubai" },
            { "name": "Juvederm Fillers", "link": "/services/juvederm-fillers" },
            { "name": "Jawline Fillers", "link": "/services/jawline-fillers-dubai" },
            { "name": "Teosyal Fillers", "link": "/services/teosyal-fillers" },
            { "name": "Under Eye Fillers", "link": "/services/under-eye-fillers-dubai" }
            ]
        },
        "benefits": {
            "heading": "The advantages of lip fillers",
            "subheading": "",
            "para": "Since lip fillers have several aesthetic and confidence-boosting benefits, they are a popular choice for those who wish to look better. These are some of the more notable advantages.",
            "items": [
                {
                    "title": "Instant Results",
                    "desc": "A noticeable improvement in lip volume and definition shortly after surgery.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Non-Surgical",
                    "desc": "Quick, minimally invasive surgery that doesn't involve any recuperation time.",
                    "icon": "fa-solid fa-hospital-user"
                },
                {
                    "title": "Flexible",
                    "desc": "The amount of filler used can be changed to suit your particular aesthetic goals.",
                    "icon": "fa-solid fa-sliders"
                },
                {
                    "title": "Natural Texture and Appearance",
                    "desc": "Hyaluronic acid-based fillers provide a subtle, natural-looking enhancement.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Quick Process",
                    "desc": "People with busy schedules will find the treatment ideal as it often takes less than half an hour.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "Enhanced Confidence in Oneself",
                    "desc": "Fuller lips can boost self-esteem by giving the face a more youthful, harmonious appearance.",
                    "icon": "fa-solid fa-face-grin-hearts"
                }
            ]
        },
        "eligibility": {
            "heading": "Lip fillers: Who Can Get Them?",
            "subheading": "",
            "para": "Fillers are an effective and safe treatment, but not everyone is a good fit for them. Here is a breakdown of who stands to gain from this treatment.",
            "items": [
                {
                    "title": "Volume Seekers",
                    "desc": "Those who want their lips to be bigger and more defined.",
                    "icon": "fa-solid fa-plus"
                },
                {
                    "title": "Aging Concerns",
                    "desc": "Those seeking to replenish volume lost as a result of aging.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Asymmetry Correction",
                    "desc": "Anyone who wants to fix lopsided or uneven lips.",
                    "icon": "fa-solid fa-balance-scale"
                },
                {
                    "title": "Natural Enhancement",
                    "desc": "Those who want to improve the natural shape of their lips.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Health Requirements",
                    "desc": "Adults without filler ingredient allergies and in generally good health.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Non-Surgical Preference",
                    "desc": "Customers seeking non-surgical, short-term lip augmentation.",
                    "icon": "fa-solid fa-hand-peace"
                },
                {
                    "title": "Confidence Boost",
                    "desc": "People who want a striking or subtle style to increase their confidence.",
                    "icon": "fa-solid fa-star"
                }
            ]
        },
        "preparationTips": {
            "heading": "How to Get Ready for Injections of Lip Fillers",
            "subheading": "",
            "para": "A more seamless process and improved outcomes are guaranteed by adequate planning. Before your appointment, you should be aware of the following.",
            "items": [
                {
                    "title": "Steer clear of blood thinners",
                    "desc": "To lower the chance of bruising, avoid taking aspirin, ibuprofen, or other blood-thinning drugs for at least a week before to your treatment.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Don't Drink Alcohol",
                    "desc": "Alcohol might exacerbate swelling and bruises, so abstain from it for at least 24 hours before to the surgery.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Drink plenty of water",
                    "desc": "Water consumption keeps your skin moisturized, which can improve the treatment's results.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Absence of makeup",
                    "desc": "Show up without any skincare products or makeup on your face.",
                    "icon": "fa-solid fa-face-rolling-eyes"
                }
            ]
        },
        "results": {
            "heading": "Findings",
            "subheading": "",
            "para": "One of the primary causes of lip fillers' continued popularity as a treatment is their outcomes. Here are some expectations regarding recovery and outcomes.",
            "items": [
                {
                    "title": "Instantaneous Volume",
                    "desc": "Following the operation, lips will look larger, while there may be some swelling for the first 24 to 48 hours.",
                    "icon": "fa-solid fa-gauge-high"
                },
                {
                    "title": "Last Gaze",
                    "desc": "The filler takes one to two weeks to fully settle and show off the finished product.",
                    "icon": "fa-solid fa-calendar-week"
                },
                {
                    "title": "Lifespan",
                    "desc": "Results usually last six to twelve months, after which you can choose to get a touch-up to keep the desired appearance.",
                    "icon": "fa-solid fa-hourglass"
                },
                {
                    "title": "Enhancement by Nature",
                    "desc": "Fuller, well-contoured lips without looking overdone should be the consequence of using the right injection procedures.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long do lip fillers last?",
                    "answer": "Lip fillers typically last between 6 to 12 months, but this can vary based on the type of filler and your body's metabolism."
                },
                {
                    "question": "Do Lip Fillers Permanently Change Lips?",
                    "answer": "No, lip fillers do not permanently change your lips. They provide temporary volume and shape enhancements that gradually wear off over time."
                },
                {
                    "question": "Are lip fillers painful?",
                    "answer": "Most patients report minimal discomfort. A numbing cream is applied before the procedure, making the injections as comfortable as possible."
                },
                {
                    "question": "What is the downtime after lip fillers?",
                    "answer": "There is little to no downtime. You may experience mild swelling or bruising, but this usually resolves within a few days."
                }
            ]
        },
        "treatmentAreas1": [
        ],
        "treatmentAreas2": [

        ]
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/ebh-services-uae-4-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Dermal-Filler-1.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Dermal-Filler-2.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Botox-Lip-Flip-Dubai-3.jpg"
            ]
        },
        "product": {
            "id": 110,
            "title": "Lip Filler Enhancement Package",
            "price": 399,
            "description": "Enhance your lips with top-quality fillers like Juvederm, Stylage, and Teosyal for a naturally fuller, well-defined look. Performed by expert injectors at Elite Body Home."
        },
    },
    "ar": {
    "url": "",
    "meta": {
        "title": "فيلر الشفاه في دبي | أفضل عيادة لفيلر الشفاه في الإمارات",
        "description": "تقدم عيادة Elite Body Home أفضل فيلر للشفاه في دبي باستخدام منتجات مميزة مثل جوفيديرم وستايلج وتيوسيال للحصول على شفاه ممتلئة طبيعية.",
        "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
        "canonical": "https://elitebodyhome.com/services/lip-fillers-dubai/",
        "og": {
            "locale": "ar_AR",
            "type": "article",
            "title": "فيلر الشفاه في دبي | أفضل عيادة لفيلر الشفاه في الإمارات",
            "description": "تقدم عيادة Elite Body Home أفضل فيلر للشفاه في دبي باستخدام منتجات مميزة مثل جوفيديرم وستايلج وتيوسيال للحصول على شفاه ممتلئة طبيعية.",
            "url": "https://elitebodyhome.com/services/lip-fillers-dubai/",
            "site_name": "elitebodyhome.com",
            "updated_time": "2024-12-30T10:39:41+00:00",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-41.jpg",
            "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-41.jpg",
            "image_width": 1254,
            "image_height": 700,
            "image_alt": "فيلر الشفاه في دبي",
            "image_type": "image/jpeg"
        },
        "twitter": {
            "card": "summary_large_image",
            "title": "فيلر الشفاه في دبي | أفضل عيادة لفيلر الشفاه في الإمارات",
            "description": "تقدم عيادة Elite Body Home أفضل فيلر للشفاه في دبي باستخدام منتجات مميزة مثل جوفيديرم وستايلج وتيوسيال للحصول على شفاه ممتلئة طبيعية.",
            "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-41.jpg"
        }
    },
    "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر الشفاه دبي"],
    "hero": {
        "title": "فيلر الشفاه في دبي",
        "subtitle": "ابتسامة تعبر عن الجمال!",
        "description": "تعريف الجمال في ابتسامة جذابة! هل ترغبين في شفاه ممتلئة وأكثر شبابًا؟ يمكن لفيلر الشفاه أن يمنحك الشفاه التي تحلمين بها بنتائج طبيعية تعزز ملامحك بالكامل. تقدم عيادتنا في دبي إجراءات فيلر الشفاه بسرعة وسهولة، ما يساعد على تحديد شكل شفتيكِ، وزيادة حجمهما، وتنعيم التجاعيد الدقيقة بها."
    },
    "howItWorks": {
        "title": "كيف يعمل فيلر الشفاه؟",
        "description": "يُعد فيلر الشفاه إجراء غير جراحي يعتمد على حقن مواد تعمل على زيادة حجم الشفاه وتحسين شكلها وزيادة ترطيبها. يحتوي الفيلر على حمض الهيالورونيك، وهو مادة طبيعية ينتجها الجسم للحفاظ على الترطيب، مما يمنح الشفاه مظهراً أكثر امتلاءً وترطيبًا. تندمج هذه المواد بسلاسة مع أنسجة الشفاه، لتمنحها مظهراً طبيعياً ناعماً وجذاباً."
    },
    "procedureSteps": {
        "heading": "خطوات الإجراء",
        "para": "يتم حقن الفيلر في الشفاه لتعزيز حجمها، وتنعيم الخطوط الدقيقة، وتحديد شكل الشفاه بشكل أكثر وضوحًا. يحتوي الفيلر على حمض الهيالورونيك، وهي مادة طبيعية في الجسم تساعد على ترطيب البشرة ومنحها مظهراً ممتلئاً.",
        "steps": [
            {
                "title": "الاستشارة",
                "desc": "تُجرى استشارة شاملة لتحديد أهدافك وتقييم شكل الشفاه.",
                "icon": "fa-solid fa-comment-medical"
            },
            {
                "title": "التخدير",
                "desc": "يُستخدم كريم مخدر موضعي لتقليل الشعور بالألم أثناء الحقن.",
                "icon": "fa-solid fa-spray-can"
            },
            {
                "title": "الحقن",
                "desc": "يتم حقن الفيلر بعناية في مناطق محددة من الشفاه باستخدام إبرة دقيقة للوصول إلى الحجم والشكل المطلوب.",
                "icon": "fa-solid fa-syringe"
            },
            {
                "title": "التشكيل",
                "desc": "تُدلك الشفاه بلطف بعد الحقن لتوزيع الفيلر بشكل متناسق، مما يضمن مظهراً طبيعياً وناعم.",
                "icon": "fa-solid fa-hand-sparkles"
            }
        ]
    },
    "internalLinking": {
        "heading": "اكتشف مجموعاتنا من فيلر البشرة لتعزيز جمال الوجه بالكامل",
        "items": [
            { "name": "فيلر الذقن", "link": "/services/chin-fillers-dubai" },
            { "name": "فيلر الأنف", "link": "/services/nose-fillers-dubai" },
            { "name": "فيلر جوفيديرم", "link": "/services/juvederm-fillers" },
            { "name": "فيلر خط الفك", "link": "/services/jawline-fillers-dubai" },
            { "name": "فيلر تيوسيال", "link": "/services/teosyal-fillers" },
            { "name": "فيلر تحت العين", "link": "/services/under-eye-fillers-dubai" }
        ]
    },
    "benefits": {
        "heading": "مزايا فيلر الشفاه",
        "subheading": "",
        "para": "نظرًا لما يقدمه فيلر الشفاه من فوائد جمالية وزيادة في الثقة بالنفس، فهو خيار شائع لمن يرغب في تحسين شكل الشفاه. إليك أبرز مميزاته:",
        "items": [
            {
                "title": "نتائج فورية",
                "desc": "تحسين فوري وواضح في حجم الشفاه وتحديدها بعد الإجراء.",
                "icon": "fa-solid fa-bolt"
            },
            {
                "title": "إجراء غير جراحي",
                "desc": "يُعد إجراء سريع وغير جراحي، ولا يتطلب فترة تعافي.",
                "icon": "fa-solid fa-hospital-user"
            },
            {
                "title": "مرونة في النتائج",
                "desc": "يمكن تعديل كمية الفيلر المستخدمة وفقًا لرغباتك الشخصية.",
                "icon": "fa-solid fa-sliders"
            },
            {
                "title": "ملمس ومظهر طبيعي",
                "desc": "توفر الفيلر المحتوي على حمض الهيالورونيك تعزيزًا طبيعيًا لشكل الشفاه.",
                "icon": "fa-solid fa-leaf"
            },
            {
                "title": "إجراء سريع",
                "desc": "يلائم من يمتلكون جداول مزدحمة، حيث يستغرق أقل من 30 دقيقة.",
                "icon": "fa-solid fa-stopwatch"
            },
            {
                "title": "تعزيز الثقة بالنفس",
                "desc": "تمنح الشفاه الممتلئة مظهرًا أكثر شبابًا وتناسقًا، مما يعزز الثقة بالنفس.",
                "icon": "fa-solid fa-face-grin-hearts"
            }
        ]
    },
    "eligibility": {
        "heading": "المرشح المناسب لفيلر الشفاه",
        "subheading": "",
        "para": "يُعد فيلر الشفاه علاجًا فعالًا وآمنًا، لكنه قد لا يناسب الجميع. إليك الفئات التي يمكنها الاستفادة من هذا الإجراء:",
        "items": [
            {
                "title": "الراغبون في زيادة الحجم",
                "desc": "الأشخاص الذين يرغبون في زيادة حجم الشفاه وتحسين تحديدها.",
                "icon": "fa-solid fa-plus"
            },
            {
                "title": "مشاكل التقدم في العمر",
                "desc": "الأشخاص الذين يرغبون في استعادة حجم شفاههم المفقود بسبب التقدم في العمر.",
                "icon": "fa-solid fa-hourglass-half"
            },
            {
                "title": "تصحيح عدم التناسق",
                "desc": "الأشخاص الذين يرغبون في تصحيح عدم التناسق أو تفاوت حجم الشفاه.",
                "icon": "fa-solid fa-balance-scale"
            },
            {
                "title": "تحسين طبيعي",
                "desc": "الأشخاص الذين يسعون إلى تحسين الشكل الطبيعي لشفاههم.",
                "icon": "fa-solid fa-heart"
            },
            {
                "title": "متطلبات صحية",
                "desc": "البالغون الأصحاء الذين لا يعانون من حساسية تجاه مكونات الفيلر.",
                "icon": "fa-solid fa-heart-pulse"
            },
            {
                "title": "تفضيل الإجراء غير الجراحي",
                "desc": "الأشخاص الذين يبحثون عن خيار غير جراحي ومؤقت لتحسين مظهر الشفاه.",
                "icon": "fa-solid fa-hand-peace"
            },
            {
                "title": "تعزيز الثقة",
                "desc": "الأشخاص الذين يرغبون في إطلالة ناعمة أو جريئة لتعزيز ثقتهم بأنفسهم.",
                "icon": "fa-solid fa-star"
            }
        ]
    },
    "preparationTips": {
        "heading": "الاستعداد لحقن فيلر الشفاه",
        "subheading": "",
        "para": "يضمن التحضير الجيد إجراءً سلسًا ونتائج أفضل. إليك ما يجب معرفته قبل موعدك:",
        "items": [
            {
                "title": "تجنب مميعات الدم",
                "desc": "امتنع عن تناول الأسبرين أو الإيبوبروفين أو الأدوية مميعة للدم لمدة لا تقل عن أسبوع قبل الجلسة، لتقليل من خطر التورم والكدمات.",
                "icon": "fa-solid fa-pills"
            },
            {
                "title": "الامتناع عن الكحول",
                "desc": "يمكن أن يزيد الكحول من التورم والكدمات، لذا يُفضل تجنبه لمدة 24 ساعة على الأقل قبل الإجراء.",
                "icon": "fa-solid fa-wine-glass-empty"
            },
            {
                "title": "الحفاظ على ترطيب الجسم",
                "desc": "يساعد الترطيب الجيد في تعزيز النتائج، لذا احرص على شرب كمية كافية من الماء قبل الجلسة.",
                "icon": "fa-solid fa-glass-water"
            },
            {
                "title": "تجنب مستحضرات التجميل",
                "desc": "يُفضل الحضور ببشرة نظيفة تمامًا وخالية من المكياج أو أي مستحضرات للعناية بالبشرة.",
                "icon": "fa-solid fa-face-rolling-eyes"
            }
        ]
    },
    "results": {
        "heading": "النتائج",
        "subheading": "",
        "para": "يُعد فيلر الشفاه من أكثر العلاجات التجميلية شيوعًا نظرًا لنتائجه الفعالة. إليك ما يمكنك توقعه بعد الإجراء:",
        "items": [
            {
                "title": "زيادة فورية في الحجم",
                "desc": "يبدو حجم الشفاه أكبر بعد الإجراء فورًا، مع احتمال حدوث تورم خفيف خلال الـ 24 إلى 48 ساعة الأولى.",
                "icon": "fa-solid fa-gauge-high"
            },
            {
                "title": "النتائج النهائية",
                "desc": "يستغرق الفيلر من أسبوع إلى أسبوعين للاستقرار بالكامل وظهور النتائج النهائية.",
                "icon": "fa-solid fa-calendar-week"
            },
            {
                "title": "نتائج تدوم طويلًا",
                "desc": "تدوم النتائج عادةً من 6 إلى 12 شهرًا، وبعد ذلك يمكن إجراء جلسة للحفاظ على المظهر المطلوب.",
                "icon": "fa-solid fa-hourglass"
            },
            {
                "title": "مظهر طبيعي محسّن",
                "desc": "ستكون النتيجة شفاه ممتلئة ومحددة دون مظهر مبالغ فيه عند الحقن بطريقة صحيحة ومُتقنة.",
                "icon": "fa-solid fa-face-smile"
            }
        ]
    },
    "aftercareTips": {
        "heading": "",
        "subheading": "",
        "para": "",
        "items": [
            {
                "title": "",
                "desc": "",
                "icon": "fa-solid fa-water"
            }
        ]
    },
    "faqData": {
        "heading": "الأسئلة الشائعة",
        "subheading": "",
        "items": [
            {
                "question": "كم تدوم نتائج فيلر الشفاه؟",
                "answer": "عادةً ما تدوم نتائج فيلر الشفاه من 6 إلى 12 شهرًا، ولكن قد يختلف هذا بناءً على نوع الفيلر المستخدم وطبيعة جسمك."
            },
            {
                "question": "هل يغير فيلر الشفاه شكل الشفاه بشكل دائم؟",
                "answer": "لا، لا يغير فيلر الشفاه شكل شفتيك بشكل دائم. فهو يوفر تحسينات مؤقتة للحجم والشكل تتلاشى تدريجيًا مع الوقت."
            },
            {
                "question": "هل فيلر الشفاه مؤلم؟",
                "answer": "يشعر معظم المرضى بانزعاج بسيط. يتم تطبيق كريم مخدر قبل الإجراء لجعل الحقن مريحًا قدر الإمكان."
            },
            {
                "question": "ما هي فترة التعافي بعد فيلر الشفاه؟",
                "answer": "لا توجد فترة تعافي تذكر. قد تعانين من تورم أو كدمات خفيفة، ولكنها تختفي عادةً خلال بضعة أيام."
            }
        ]
    },
    "treatmentAreas1": [],
    "treatmentAreas2": []
}
};
